import { useState, useCallback } from 'react';
import { getHistorialLibranzas, HistorialLibranzasPayload } from '@/services/getHistorialLibranzas';

export interface UseHistorialLibranzasResult {
    rows: Record<string, any>[];
    loading: boolean;
    notFound: boolean;
    fetch: (payload: HistorialLibranzasPayload) => void;
}

export function useHistorialLibranzas(): UseHistorialLibranzasResult {
    const [rows, setRows] = useState<Record<string, any>[]>([]);
    const [loading, setLoading] = useState(false);
    const [notFound, setNotFound] = useState(false);

    const fetch = useCallback((payload: HistorialLibranzasPayload) => {
        setLoading(true);
        setNotFound(false);
        getHistorialLibranzas(payload)
            .then((response) => {
                if (response?.status === 404) {
                    setRows([]);
                    setNotFound(true);
                    return;
                }
                const data = response?.data?.data;
                setRows(Array.isArray(data) ? data : []);
            })
            .catch(() => {
                setRows([]);
            })
            .finally(() => {
                setLoading(false);
            });
    }, []);

    return { rows, loading, notFound, fetch };
}
